var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCapella(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9028 2H4.14834C2.97187 2 2 2.97187 2 4.14834V19.8517C2 21.0281 2.97187 22 4.14834 22H19.8517C21.0281 22 22 21.0281 22 19.8517V4.09719C22 2.92072 21.0793 2 19.9028 2ZM16.0153 6.75703L16.7826 7.5243L14.2762 10.0307L13.509 9.26343L16.0153 6.75703ZM7.57545 6.75703L10.0818 9.26343L9.31458 10.0307L6.80818 7.5243L7.57545 6.75703ZM7.57545 16.9361L6.80818 16.1688L9.31458 13.6624L10.0818 14.4297L7.57545 16.9361ZM10.1841 12.6394H4.9156V11.0026H10.1841C10.6445 11.0026 11.0026 11.3606 11.0026 11.821C11.0026 12.2813 10.6445 12.6394 10.1841 12.6394ZM12.7417 19.0844H11.1049V13.8159C11.1049 13.3555 11.4629 12.9974 11.9233 12.9974C12.3836 12.9974 12.7417 13.3555 12.7417 13.8159V19.0844ZM12.7417 10.133C12.7417 10.5934 12.3836 10.9514 11.9233 10.9514C11.4629 10.9514 11.1049 10.5934 11.1049 10.133V4.86445H12.7417V10.133ZM16.0153 16.9361L13.509 14.4297L14.2762 13.6624L16.7826 16.1688L16.0153 16.9361ZM19.1355 12.6394H13.867C13.4066 12.6394 13.0486 12.2813 13.0486 11.821C13.0486 11.3606 13.4066 11.0026 13.867 11.0026H19.1355V12.6394Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapella);
export default __webpack_public_path__ + "static/media/capella.a903a345.svg";
export { ForwardRef as ReactComponent };